<template>
  <div>
    <v-card class="mx-auto mt-5" outlined >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" dark small class="float-end" @click="Save">
                 {{ $t("btn.Save") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <text-editor ref="answersit"></text-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogComplete=false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import TextEditor from './text-editor';
  export default {
    components: {
      TextEditor
    },
    data() {
      return {
        text:'',
        dialogComplete:false,
      };
    },

    methods: {
      GetData(){

      },
      Save(){
         this.$store.commit('set_overlay',true);
          let formData = new FormData();
          formData.append('Text',this.$refs.answersit.content);
          formData.append('locale',this.$store.getters.authen.locale);
          this.req.post(this.$store.getters.base_api + 'post-text-aboutus',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
      }
    },
    mounted() {
      this.req = this.$store.getters.req;
    },



  };
</script>
